"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const toMarkdown = (element, _context) => {
    if (!element.value) {
        return '';
    }
    const { resultSuccessTitle, resultFailTitle, resultFeedbackCommon, resultFeedbackSuccess, resultFeedbackFail, showFeedback, } = element.value;
    if (!showFeedback) {
        return '';
    }
    const sections = [];
    sections.push('**Test Results**');
    sections.push('');
    if (resultSuccessTitle) {
        sections.push(`**Success Title:** ${resultSuccessTitle}`);
    }
    if (resultFailTitle) {
        sections.push(`**Fail Title:** ${resultFailTitle}`);
    }
    if (resultFeedbackCommon) {
        sections.push(`**Common Feedback:** ${resultFeedbackCommon}`);
    }
    if (resultFeedbackSuccess) {
        sections.push(`**Success Feedback:** ${resultFeedbackSuccess}`);
    }
    if (resultFeedbackFail) {
        sections.push(`**Fail Feedback:** ${resultFeedbackFail}`);
    }
    if (sections.length === 2) {
        return '';
    }
    return sections.join('\n') + '\n\n';
};
exports.toMarkdown = toMarkdown;
